import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Check, Select } from 'ui/fields';
import { buildConfiguration, buildDesign, buildPlaygroundPopup, SHOW_AFTER_TIME_DEFAULTS, TRIGGER_DEFAULTS, } from '../../fixtures/popupPlaygroundFixtures.js';
const PRESENTATION_TYPES = ['POPUP', 'SIDE_PANEL', 'NOTIFICATION', 'ANNOUNCEMENT_BAR'];
const FREQUENCY_TYPES = ['SHOW_ONCE', 'SHOW_AFTER_TIME', 'SHOW_ALWAYS'];
const TRIGGER_LABELS = {
    exitIntent: 'Exit intent',
    inactivity: `Inactividad (${TRIGGER_DEFAULTS.inactivitySeconds}s)`,
    scroll: `Scroll (${TRIGGER_DEFAULTS.scrollPercentage}%)`,
    afterTimeElapsed: `Tiempo en página (${TRIGGER_DEFAULTS.afterTimeElapsedSeconds}s)`,
    autoHide: `Auto-ocultar (${TRIGGER_DEFAULTS.autoHideSeconds}s)`,
};
const INITIAL_TRIGGERS = {
    exitIntent: false,
    inactivity: false,
    scroll: false,
    afterTimeElapsed: false,
    autoHide: false,
};
export function PopupPlaygroundForm({ existingIds, onAdd }) {
    const [presentationType, setPresentationType] = useState('POPUP');
    const [frequencyType, setFrequencyType] = useState('SHOW_ONCE');
    const [triggers, setTriggers] = useState(INITIAL_TRIGGERS);
    function toggleTrigger(key) {
        setTriggers((prev) => (Object.assign(Object.assign({}, prev), { [key]: !prev[key] })));
    }
    function handleAdd() {
        const configuration = buildConfiguration({
            triggers: {
                exitIntent: triggers.exitIntent,
                inactivity: { enabled: triggers.inactivity, seconds: TRIGGER_DEFAULTS.inactivitySeconds },
                scroll: { enabled: triggers.scroll, percentage: TRIGGER_DEFAULTS.scrollPercentage },
                afterTimeElapsed: {
                    enabled: triggers.afterTimeElapsed,
                    seconds: TRIGGER_DEFAULTS.afterTimeElapsedSeconds,
                },
                autoHide: { enabled: triggers.autoHide, seconds: TRIGGER_DEFAULTS.autoHideSeconds },
            },
            frequency: Object.assign({ frequencyType }, (frequencyType === 'SHOW_AFTER_TIME' ? SHOW_AFTER_TIME_DEFAULTS : {})),
        });
        const id = Math.max(9000, ...existingIds) + 1;
        onAdd(buildPlaygroundPopup({ id, presentationType, configuration, design: buildDesign() }));
    }
    return (_jsxs("div", Object.assign({ style: { marginBottom: 16, border: '1px solid #666', padding: 12 } }, { children: [_jsxs("div", Object.assign({ style: { display: 'flex', gap: 16, marginBottom: 8 } }, { children: [_jsx(Select, Object.assign({ value: presentationType, onChange: (value) => setPresentationType(value), label: "Tipo" }, { children: PRESENTATION_TYPES.map((type) => (_jsx(Select.Option, Object.assign({ value: type }, { children: type }), type))) })), _jsx(Select, Object.assign({ value: frequencyType, onChange: (value) => setFrequencyType(value), label: "Frecuencia" }, { children: FREQUENCY_TYPES.map((type) => (_jsx(Select.Option, Object.assign({ value: type }, { children: type }), type))) }))] })), frequencyType === 'SHOW_AFTER_TIME' && (_jsxs("p", Object.assign({ style: { fontSize: 12, marginBottom: 8 } }, { children: ["Cada ", SHOW_AFTER_TIME_DEFAULTS.showEveryInterval, " ", SHOW_AFTER_TIME_DEFAULTS.frequencyUnitType.toLowerCase()] }))), _jsx("div", Object.assign({ style: { display: 'flex', flexWrap: 'wrap', gap: 16, marginBottom: 8 } }, { children: Object.keys(TRIGGER_LABELS).map((key) => (_jsx(Check, { name: key, label: TRIGGER_LABELS[key], checked: triggers[key], onChange: () => toggleTrigger(key) }, key))) })), _jsx("button", Object.assign({ type: "button", onClick: handleAdd }, { children: "Agregar popup" }))] })));
}
